import React from 'react';
import useSEO from "./useSEO";

const Pharmaceuticals = () => {
  useSEO({
    title: "Pharmaceutical Manufacturing in Hyderabad | GMP Certified Pharma Solutions",
    description:
      "Leading pharmaceutical manufacturing services in Hyderabad specializing in GMP-certified formulations, quality control, and contract manufacturing for global healthcare brands.",
    keywords:
      "pharmaceutical manufacturing Hyderabad, pharma company Hyderabad, contract manufacturing pharma, GMP certified pharma, pharma formulation Hyderabad, pharmaceutical production Hyderabad, life sciences manufacturing, API manufacturing Hyderabad, pharma quality control, pharmaceutical solutions India",
    ogTitle: "Pharmaceutical Manufacturing in Hyderabad - Quality & Compliance Driven",
    ogDescription:
      "Trusted pharmaceutical manufacturing company in Hyderabad offering GMP-compliant production, formulation, and quality testing services.",
    ogImage: "imgs/pharmaceuticals-process.jpg",
    twitterTitle: "Pharmaceutical Manufacturing in Hyderabad - Quality & Compliance Driven",
    twitterDescription:
      "Professional pharmaceutical manufacturing and formulation services in Hyderabad with GMP, WHO, and ISO-certified facilities.",
    twitterImage: "imgs/pharmaceuticals-process.jpg",
  });

  return (
    <div>
      <>
        {/* Section 1 - Introduction */}
        <section className="pt-lg-8 pt-xl-9">
          <div className="container position-relative pt-4 pt-lg-0">
            <div className="row align-items-center">
              {/* Left Text */}
              <div className="col-md-7 col-xl-6 mb-7 mb-md-0">
                <h1 className="mb-4">Pharmaceutical  </h1>
                <p className="mb-4">
                  <b>Pharmaceutical  </b> is the backbone of modern healthcare — ensuring safe, effective, and reliable medicines for global patients. 
                  We specialize in delivering high-quality formulations, adhering to GMP and WHO standards across every stage of production.
                </p>
                <p className="mb-4">
                  Our facilities are equipped with advanced machinery, sterile environments, and automated systems that guarantee consistency, quality, and regulatory compliance.
                  From raw material procurement to final packaging, we manage the complete pharmaceutical manufacturing lifecycle with precision.
                </p>
              </div>

              {/* Right Image */}
              <div className="col-md-5 ms-auto text-center">
                <img
                  src="imgs/pharmaceuticals.jpg"
                  alt="Pharmaceutical Manufacturing"
                  className="rounded-3 shadow-sm w-100"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Section 2 - Key Services */}
        <section className="overflow-hidden pb-0">
          <div className="container">
            <div className="row align-items-center">
              {/* Image */}
              <div className="col-lg-6 text-center position-relative mb-5 mb-lg-0">
                <div className="pe-lg-6 pe-xl-8">
                  <img
                    src="imgs/pharmaceuticals-process.jpg"
                    alt="Pharmaceutical Lab"
                    className="rounded-4 shadow-sm w-100"
                  />
                </div>
              </div>

              {/* Text Content */}
              <div className="col-lg-6 ms-auto">
                <h2 className="mb-lg-4">Our Pharmaceutical Capabilities:</h2>
                <hr className="my-4 my-lg-5" />

                <ul className="list-group list-group-borderless">
                  <li className="list-group-item d-flex">
                    <i className="bi bi-patch-check text-primary me-2" />
                    <b>Formulation Development</b>
                  </li>
                  <p>
                    Expertise in tablets, capsules, syrups, ointments, and injectables designed with precision and safety in mind.
                  </p>

                  <li className="list-group-item d-flex">
                    <i className="bi bi-patch-check text-primary me-2" />
                    <b>Contract Manufacturing</b>
                  </li>
                  <p>
                    Partnering with pharma brands worldwide to deliver high-quality products under strict regulatory compliance.
                  </p>

                  <li className="list-group-item d-flex">
                    <i className="bi bi-patch-check text-primary me-2" />
                    <b>API & Bulk Drug Production</b>
                  </li>
                  <p>
                    Production of Active Pharmaceutical Ingredients (APIs) and intermediates with consistent yield and purity.
                  </p>

                  <li className="list-group-item d-flex">
                    <i className="bi bi-patch-check text-primary me-2" />
                    <b>Quality Control & Assurance</b>
                  </li>
                  <p>
                    Stringent multi-stage testing and validation as per GMP, WHO, and ISO 9001 standards to ensure zero defects.
                  </p>

                  <li className="list-group-item d-flex">
                    <i className="bi bi-patch-check text-primary me-2" />
                    <b>Packaging & Labelling</b>
                  </li>
                  <p>
                    Automated packaging lines for blister packs, bottles, and cartons, ensuring product integrity and traceability.
                  </p>

                  <li className="list-group-item d-flex">
                    <i className="bi bi-patch-check text-primary me-2" />
                    <b>Regulatory Compliance</b>
                  </li>
                  <p>
                    Fully compliant with WHO-GMP, FDA, and ISO standards — backed by robust documentation and batch traceability.
                  </p>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* Section 3 - Advantages */}
        <section className="py-5">
          <div className="container">
            <div className="text-center mb-5">
              <h2 className="text-primary">Why Choose Our Pharmaceutical Services</h2>
              <p className="lead">
                We combine science, innovation, and compliance to deliver
                world-class pharmaceutical manufacturing solutions.
              </p>
            </div>

            <div className="row text-center">
              <div className="col-md-4 mb-4">
                <i className="bi bi-gear-wide-connected text-success fs-3 mb-2"></i>
                <h5>GMP Certified Facilities</h5>
                <p>
                  State-of-the-art facilities that meet international standards
                  for hygiene, safety, and efficiency.
                </p>
              </div>

              <div className="col-md-4 mb-4">
                <i className="bi bi-shield-check text-success fs-3 mb-2"></i>
                <h5>Uncompromised Quality</h5>
                <p>
                  Each batch undergoes rigorous inspection, testing, and
                  documentation before final release.
                </p>
              </div>

              <div className="col-md-4 mb-4">
                <i className="bi bi-cash-stack text-success fs-3 mb-2"></i>
                <h5>Cost-Effective Production</h5>
                <p>
                  Optimized manufacturing and logistics reduce costs without
                  compromising on quality or timelines.
                </p>
              </div>

              <div className="col-md-4 mb-4">
                <i className="bi bi-lab text-success fs-3 mb-2"></i>
                <h5>Innovation & R&D</h5>
                <p>
                  In-house research and development for continuous product
                  improvement and new formulations.
                </p>
              </div>

              <div className="col-md-4 mb-4">
                <i className="bi bi-box-seam text-success fs-3 mb-2"></i>
                <h5>End-to-End Solutions</h5>
                <p>
                  From raw material procurement to packaging and logistics —
                  we handle it all under one roof.
                </p>
              </div>

              <div className="col-md-4 mb-4">
                <i className="bi bi-globe text-success fs-3 mb-2"></i>
                <h5>Global Supply Reach</h5>
                <p>
                  Serving leading pharmaceutical companies worldwide with
                  reliable, high-volume manufacturing capacity.
                </p>
              </div>
            </div>
          </div>
        </section>
      </>
    </div>
  );
};

export default Pharmaceuticals;
